<template>
    <div>
        <!-- 顶部显示 -->
        <el-breadcrumb
            separator-class="el-icon-arrow-right"
            style="margin-bottom:10px"
        >
            <el-breadcrumb-item>活动管理</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 新增按钮 -->
        <div style="margin-bottom:15px">
            <el-button type="primary" @click="newlyAdded">添加活动</el-button>
        </div>
        <!-- 表格 -->
        <el-table
            v-loading="tableLoading"
            :data="tableData"
            style="width: 100%"
        >
            <el-table-column prop="area_name" label="景区名称">
            </el-table-column>
            <el-table-column prop="activity_name" label="活动名称">
            </el-table-column>
            <el-table-column prop="activity_link" label="活动链接">
            </el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button
                        size="mini"
                        @click="handleEdit(scope.$index, scope.row)"
                        >修改</el-button
                    >
                    <el-button
                        size="mini"
                        type="danger"
                        @click="handleDelete(scope.$index, scope.row)"
                        >删除</el-button
                    >
                </template>
            </el-table-column>
        </el-table>
        <!-- 弹框 -->
        <el-dialog
            title="添加活动"
            :visible.sync="dialogVisible"
            width="30%"
            :before-close="handleClose"
        >
            <el-form
                :model="ruleForm"
                :rules="rules"
                ref="ruleForm"
                label-width="100px"
                class="demo-ruleForm"
            >
                <el-form-item label="活动名称" prop="activity_name">
                    <el-input v-model="ruleForm.activity_name"></el-input>
                </el-form-item>
                <el-form-item label="活动内容" prop="activity_content">
                    <el-input
                        type="textarea"
                        autosize
                        v-model="ruleForm.activity_content"
                    ></el-input>
                </el-form-item>
                <el-form-item label="活动链接" prop="activity_link">
                    <el-input v-model="ruleForm.activity_link"></el-input>
                </el-form-item>
                <el-form-item label="景区选择" prop="area_id">
                    <el-select
                        v-model="ruleForm.area_id"
                        placeholder="请选择景区"
                    >
                        <el-option
                            v-for="item in scenicSpotList"
                            :label="item.area_name"
                            :value="item.area_id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submitForm('ruleForm')"
                        >立即添加</el-button
                    >
                    <el-button @click="resetForm('ruleForm')">重置</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <!-- 修改按钮的弹框 -->
        <el-dialog
            title="修改活动"
            :visible.sync="editdialogVisible"
            :rules="rules"
            width="30%"
            :before-close="handleClose"
        >
            <el-form
                :model="editInfo"
                ref="ruleForm"
                label-width="100px"
                class="demo-ruleForm"
            >
                <el-form-item label="活动名称" prop="activity_name">
                    <el-input v-model="editInfo.activity_name"></el-input>
                </el-form-item>
                <el-form-item label="活动内容" prop="activity_content">
                    <el-input
                        type="textarea"
                        autosize
                        v-model="editInfo.activity_content"
                    ></el-input>
                </el-form-item>
                <el-form-item label="活动链接" prop="activity_link">
                    <el-input v-model="editInfo.activity_link"></el-input>
                </el-form-item>
                <el-form-item label="景区选择" prop="area_id">
                    <el-select
                        v-model="editInfo.area_id"
                        placeholder="请选择景区"
                    >
                        <el-option
                            v-for="item in scenicSpotList"
                            :label="item.area_name"
                            :value="item.area_id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button
                        type="primary"
                        @click="submitFormedit('editInfo')"
                        >立即修改</el-button
                    >
                    <el-button @click="resetFormedit('editInfo')"
                        >取消</el-button
                    >
                </el-form-item>
            </el-form>
        </el-dialog>
        <!-- 分页 -->
        <div>
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 30, 40]"
                :page-size="pageSize"
                layout="total,  prev, pager, next, jumper"
                :total="total"
                style="text-align:right;margin:0 16px 10px 0;border-radius:20px"
            >
            </el-pagination>
        </div>
    </div>
</template>

<script>
import qs from "qs";
export default {
    props: {
        pageSize: {
            type: Number,
            default: 10
        }
    },
    data() {
        return {
            // 弹框显示与否
            dialogVisible: false,
            // 修改按钮的弹框与否
            editdialogVisible: false,
            // 修改弹框的表单
            editInfo: {},
            // 弹框---表单
            ruleForm: {},
            // 表单验证
            rules: {
                activity_name: [
                    {
                        required: true,
                        message: "请输入活动名称",
                        trigger: "blur"
                    }
                ],
                activity_content: [
                    {
                        required: true,
                        message: "请输入活动内容",
                        trigger: "blur"
                    }
                ],
                activity_link: [
                    {
                        required: true,
                        message: "请输入活动链接",
                        trigger: "blur"
                    }
                ],
                area_id: [
                    { required: true, message: "请选择景区", trigger: "change" }
                ]
            },
            tableData: [],
            currentPage: 1, //分页
            total: 0, //分页
            scenicSpotList: [], //获取景区的数组
            ids: [],
            tableLoading: true
        };
    },
    methods: {
        // 点击新增按钮显示弹框
        newlyAdded() {
            this.dialogVisible = true;
        },
        // 点击叉号关闭弹框
        handleClose() {
            this.dialogVisible = false;
            this.editdialogVisible = false;
        },
        // 立即添加按钮
        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    let that = this;
                    let userData = qs.parse(sessionStorage.getItem("userData"));
                    let salesInfoData = this.ruleForm;
                    let salesInfoParams = {
                        methodUrl: "/admin/addAreaActivity",
                        jsonParam: qs.stringify(salesInfoData)
                    };
                    this.$axios.postRequest(salesInfoParams).then(
                        function(res) {
                            // 成功后的处理
                            if (res.code == 0) {
                                that.dialogVisible = false;
                                that.$refs["ruleForm"].resetFields();
                                that.$message({
                                    message: "新增成功",
                                    type: "success"
                                });
                                that.findActivityList();
                                that.$refs[formName].resetFields();
                            } else {
                                if (res.code == -1001) {
                                    that.$message.error(
                                        "该景区已有活动，请直接修改或删除后重新创建"
                                    );
                                } else {
                                    that.$message.error(res.msg);
                                }
                            }
                        },
                        function(res) {
                            //失败之后处理逻辑
                            that.$message.error("网络错误，请稍后重试");
                        }
                    );
                } else {
                    return false;
                }
            });
        },
        // 重置按钮
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        // 获取景区列表
        findScenicSpotList() {
            var userData = qs.parse(sessionStorage.getItem("userData"));
            var that = this;
            var salesInfoData = {
                pageindex: 1,
                pagesize: 9999
            };
            var salesInfoParams = {
                methodUrl: "/admin/getScenicArea",
                jsonParam: qs.stringify(salesInfoData)
            };
            this.$axios.postRequest(salesInfoParams).then(
                function(res) {
                    //成功之后处理逻辑
                    that.scenicSpotList = res.data.list;
                },
                function(res) {
                    //失败之后处理逻辑
                }
            );
        },
        // 查询活动列表
        findActivityList() {
            let that = this;
            let packageList = [];
            let salesInfoData = {
                count: true,
                pageindex: this.currentPage,
                pagesize: this.pageSize
            };
            let salesInfoParams = {
                methodUrl: "/admin/getAreaActivity",
                jsonParam: qs.stringify(salesInfoData)
            };
            this.tableLoading = true;
            this.$axios.postRequest(salesInfoParams).then(
                function(res) {
                    if (res.code == 0) {
                        that.tableLoading = false;
                        //成功之后处理逻辑
                        that.tableData = res.data.list;
                        that.total = res.data.totalcount;
                    }
                },
                function(res) {
                    //失败之后处理逻辑
                }
            );
        },
        // 表格----修改按钮
        handleEdit(index, row) {
            this.editdialogVisible = true;
            this.editInfo = row;
        },
        // 点击修改按钮发送修改请求
        submitFormedit() {
            var that = this;
            var salesInfoData = this.editInfo;
            var salesInfoParams = {
                methodUrl: "/admin/upAreaActivity",
                jsonParam: qs.stringify(salesInfoData)
            };
            this.$axios.postRequest(salesInfoParams).then(
                function(res) {
                    if (res.code == 0) {
                        that.editdialogVisible = false;
                        //成功之后处理逻辑
                        that.findActivityList();
                    } else {
                        if (res.code == -1001) {
                            that.$message.error(
                                "该景区已有活动，请直接修改或删除后重新创建"
                            );
                        } else {
                            that.$message.error(res.msg);
                        }
                    }
                },
                function(res) {
                    that.$message.error("网络错误，请稍后重试");
                }
            );
        },
        // 点击取消按钮不显示弹框
        resetFormedit() {
            this.editdialogVisible = false;
        },
        // 表格----删除按钮
        handleDelete(index, row) {
            this.$confirm("您确定要删除此活动吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                this.delActivity(row.acitivity_id);
            });
        },
        delActivity(acitivity_id) {
            let that = this;
            let salesInfoData = {
                acitivity_id: acitivity_id
            };
            let salesInfoParams = {
                methodUrl: "/admin/delAreaActivity",
                jsonParam: qs.stringify(salesInfoData)
            };
            this.$axios.postRequest(salesInfoParams).then(
                function(res) {
                    //成功之后处理逻辑
                    that.findActivityList();
                },
                function(res) {
                    //失败之后处理逻辑
                }
            );
        },
        // 分页
        handleSizeChange(val) {
            this.pageSize = val;
            this.findActivityList();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.findActivityList();
        }
    },
    mounted() {
        this.findActivityList();
        this.findScenicSpotList();
    }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/activityList.vue